export default __webpack_public_path__ + "static/skylift-a52aaf9cfd4a7f1187cd69e5eb008549.jpg";